import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// import JsonViewer from "vue3-json-viewer";
// import "vue3-json-viewer/dist/index.css";
// import JsonEditorVue from "json-editor-vue";

// import { VueDatePicker } from "@vuepic/vue-datepicker";
// import "@vuepic/vue-datepicker/dist/main.css";

export default defineNuxtPlugin({
  name: 'ui-components',
  setup() {
    const { vueApp } = useNuxtApp();
    
    // Register Global UI

    // Setup FlatPickr
    VueFlatPickr.install = (app) => {
      app.component(VueFlatPickr.name, VueFlatPickr);
    };
    vueApp.use(VueFlatPickr);

    // Setup Json Viewer Components
    // vueApp.use(JsonViewer);
    // vueApp.use(JsonEditorVue);

    return {};
  }
});